import cookie from 'react-cookies';
import { captureException } from '@sentry/node';

import { isAxiosError } from '@r1-frontend/do-request/guards/isAxiosError';
import { ResponseDto } from '@r1-frontend/api-domru/api-content/v1/geography/get-city-info';

import { isServerSide } from '@r1-frontend/shared/helpers/ssr';

import contentRequest from '~/src/api/requests/contentRequest';
import { COOKIE_DOMAIN, COOKIE_MAX_AGE_LONG, PROVIDER_ID_COOKIE } from '~/src/constants';
import { IServResponseWithCookie } from '~/src/helpers/cookie';

export enum ECityInfoExpand {
    Promolines = 'promolines',
}

interface IParams {
    domain?: string,
    city_id?: number,
    filter?: Array<string>,
    active?: boolean,
    providerId?: number,
    expand?: Array<ECityInfoExpand>,
}

interface IResp {
    ok: boolean,
    data: ResponseDto | null,
    error: string,
}

/**
 * GET-запрос свойств города
 *
 * /v1/geography/get-city-info?filter=city_id,id,domain&city_id=1&onlyActive=true
 * @param providerId - айди провайдера
 * @param domain - домен города
 * @param filter - возвращаемые поля, если не указано то вернет все
 * @param active - искать в только активных или во всех городах
 * @param expand - специальные поля
 * @returns {Promise<any|undefined>}
 */
export const getCityInfo = async({ providerId, city_id, domain, filter, active = false, expand }: IParams): Promise<IResp> => {
    const params = {
        providerId,
        city_id,
        domain,
        filter: filter?.join(','),
        onlyActive: active,
        expand: expand?.join(','),
    };

    try {
        const resp = await contentRequest.get('/v1/geography/get-city-info', { params });

        return {
            ok: true,
            data: resp.data,
            error: '',
        };
    } catch (err) {
        if (isAxiosError(err)) {
            return {
                ok: false,
                data: null,
                error: err.response?.statusText || '',
            };
        }

        captureException(err);

        return {
            ok: false,
            data: null,
            error: 'Внутренняя ошибка сервера',
        };
    }
};

export const setProviderIdCookie = (providerId: number, response?: IServResponseWithCookie): void => {
    const cookieConfig = {
        maxAge: COOKIE_MAX_AGE_LONG,
        domain: COOKIE_DOMAIN,
        path: '/',
    };

    if (isServerSide()) {
        response?.cookie(PROVIDER_ID_COOKIE, providerId, cookieConfig);
    } else {
        cookie.save(PROVIDER_ID_COOKIE, providerId, cookieConfig);
    }
};
